<div mat-dialog-title style="display: inline-flex; align-items: center; justify-content: space-between;">
    <h2 style="margin: 0;">Split Review Set</h2>
    <div style="margin-left: auto; display: inline-flex; align-items: center; justify-content: flex-end; gap: 16px;">
        <div style="font-size: 16px; color: inherit; background-color: inherit; cursor: pointer;" (click)="close()">
            <span class="fal fa-times"></span>
        </div>
    </div>
</div>
<mat-dialog-content style="overflow: hidden; width: 350px; height: 225px;">
    <div *ngIf="reviewSet$ | async as reviewSet" style="display: flex; flex-direction: column;">
        <div *ngIf="!splitWorkflow"
            style="display: flex; flex-direction: column; align-items: center; margin-bottom: 24px;">
            <div style="padding: 24px 32px; gap: 16px; flex-grow: 1;">
                <div style="margin-bottom: 12px;"><b>{{reviewSet.name}}</b></div>
                <mat-form-field appearance="fill">
                    <mat-label>Number of new Review Sets</mat-label>
                    <mat-select [(value)]="selectedNumber">
                        <mat-option *ngFor="let num of numbers" [value]="num">
                            {{ num }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="splitWorkflow" style="display: flex; flex-direction: column; align-items: center;">
            <div style="padding: 24px 32px; display: flex; justify-content: center; flex-direction: column;">
                <div style="margin-top: 8px; margin-bottom: 8px;">
                    <b>{{reviewSet.name}}</b> is being split into additional review sets. Once completed, please refresh the page to see the results.</div>
                <div>You may close this window at any time.</div>
            </div>
            <span *ngIf="splitWorkflow?.executionState === 'New' || 'Started' || 'Active'" class="loader"></span>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions
    style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <button mat-raised-button color="primary" (click)="startSplitReviewSet()"
        [disabled]="!selectedNumber || splitWorkflow">Split</button>
    <button mat-raised-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>